import { TransactionOriginatorTypeGroup } from '@features/transactions/enums/transactionOriginatorTypeGroup'

import { useTransactionsListFilters } from '../../../../../contexts/transactionsListFiltersContext'

const ALL_TYPE_GROUPS_COUNT = Object.values(TransactionOriginatorTypeGroup).length

/* All types/journals applied = 0 filters (because all applied by default and filter is excluding types) */
/* 1 type applied = 1 filter */
export const useTransactionsActiveFiltersCount = (): number => {
  const {
    appliedFilters: { journalCode, originatorTypeGroup, withVoided },
  } = useTransactionsListFilters()

  const selectedTypeGroupsCount = originatorTypeGroup?.length ?? ALL_TYPE_GROUPS_COUNT
  const typeGroupsFilterCount = selectedTypeGroupsCount === ALL_TYPE_GROUPS_COUNT ? 0 : selectedTypeGroupsCount

  return typeGroupsFilterCount + (journalCode?.length ?? 0) + (withVoided ? 1 : 0)
}
